export default {"src":"/_next/static/media/XPO.780c0416.svg","height":18,"width":18};